import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import "./CtmsWorkspaceModal.scss";

export default function CtmsWorkspaceModal({
  open,
  title = "Workspace",
  titleId = "ctms-workspace-title",
  onClose,
  children,
  className = "",
  dialogClassName = "",
  contentClassName = "",
}) {
  useEffect(() => {
    if (!open) return undefined;
    const previous = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = previous;
    };
  }, [open]);

  if (!open) return null;

  return createPortal(
    <div
      className={`modal fade show d-block ctms-workspace-modal ${className}`.trim()}
      role="dialog"
      aria-modal="true"
      aria-labelledby={titleId}
    >
      <div
        className={`modal-dialog ctms-workspace-modal__dialog ${dialogClassName}`.trim()}
      >
        <div
          className={`modal-content ctms-workspace-modal__content ${contentClassName}`.trim()}
        >
          <div className="ctms-workspace-modal__header">
            <h5 className="modal-title" id={titleId}>
              {title}
            </h5>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={onClose}
            />
          </div>
          <div className="ctms-workspace-modal__body">{children}</div>
        </div>
      </div>
    </div>,
    document.body,
  );
}
